import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CategoryModel } from '../models/category.model';
import { UserService } from './user.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class CourierService {

  BaseURI : string;
  readonly apiController = "/Couriers";
  form : FormGroup = CategoryModel.getFormGroup();
  
  constructor(private http : HttpClient, private userservice : UserService) { 
    console.log("constructor : CourierService ");
    this.BaseURI = window.location.origin + "/api";
  }

  populateForm(item) {
    this.form.setValue(item);
   }
 
   getDetail(id) 
   {
      return this.http.get(this.BaseURI + this.apiController + "/" + id);
   }
 
   getList()
   {
      return this.http.get(this.BaseURI + this.apiController);
       
   }

   
   insertData(item : CategoryModel) {
     item.createBy = this.userservice.getUserID();
     return this.http.post(this.BaseURI + this.apiController, _.omit(item, ["id", "createTime"]));
   }
 
   updateData(item : CategoryModel) {
     return this.http.put(this.BaseURI + this.apiController + "/" + item.id, item);
   }
 
   deleteData(id)
   {
     return this.http.delete(this.BaseURI + this.apiController + "/" + id);
  
   }
   
   initializeFormGroup(){
      CategoryModel.initializeFormGroup(this.form);
   }
}
